import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Closing() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="174691" id="penutup-resmi" className="bg-background text-foreground py-24 px-6 sm:px-12 md:px-12 lg:px-24 flex flex-col items-center justify-center min-h-[60vh] sm:min-h-[70vh] lg:min-h-[80vh]">
      <div className="flex-1 flex flex-col items-center justify-center max-w-4xl mx-auto w-full text-center">
        <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight mb-12 text-foreground">
          Kami berkomitmen untuk menyajikan informasi yang akurat dan berimbang demi kepentingan publik.
        </h2>
        
        <Button asChild variant="outline" size="lg" className="bg-primary border-none text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground transition-all shadow-md rounded-md px-8 sm:px-12 h-12 sm:h-14 text-base sm:text-lg font-semibold">
          <Link to="#">
            Hubungi Redaksi
          </Link>
        </Button>
      </div>

      <div className="w-full max-w-6xl mt-32 pt-10 border-t border-border/50 flex flex-col sm:flex-row justify-between items-center gap-8 sm:gap-12 font-mono text-[12px] sm:text-[13px] text-muted-foreground">
        <nav className="flex items-center gap-8 sm:gap-10">
          <Link to="#" className="hover:text-primary transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring rounded-sm font-sans uppercase tracking-wider">
            Beranda
          </Link>
          <Link to="#" className="hover:text-primary transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring rounded-sm font-sans uppercase tracking-wider">
            Berita
          </Link>
        </nav>
        
        <div className="text-center sm:text-right font-serif italic text-primary tracking-widest text-[14px]">
          &copy; {currentYear} ABADI.NEWS. SELURUH HAK CIPTA DILINDUNGI.
        </div>
      </div>
    </section>;
}